import Vue from 'vue';
import moment from 'moment';
import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'points-collected';
    loadNewPointsCollected = () => {
        return this.get({
            params: {
                'response-group': 'short',
                limit: -1,
                filter: [
                    {
                        type: 'gte',
                        field: 'date',
                        format: 'd.m.Y H:i:s',
                        value: moment()
                            .set({ h: 0, m: 0, s: 0 })
                            .subtract(7, 'd')
                            .format('DD.MM.YYYY HH:mm:ss'),
                    },
                    {
                        type: 'eq',
                        field: 'organization',
                        value: Vue.$store.state.organization.selectedOrganizationID,
                    },
                ],
            },
        });
    };

    getParticipantsWithPoints = pointsCollected => {
        return pointsCollected.map(points => (points.participant ? points.participant.id : null)).filter(Boolean);
    };
}

export const PointsCollectedModel = new model();
